import React from 'react';
import './whowe.css';
import { FaPhone, FaEnvelope } from 'react-icons/fa';
import aboutContent from '../../../content/pages/about.json';

const WhoWe = () => {
    const { employees } = aboutContent;

    return (
        <section className="whowe-container">
            {employees.map((employee, index) => (
                <div key={index} className="employee-card">
                    <h3>{employee.name}</h3>
                    <p>{employee.role}</p>
                    <p>
                        <FaPhone /> {employee.phoneNumber}
                    </p>
                    <p>
                        <FaEnvelope /> {employee.email}
                    </p>
                </div>
            ))}
        </section>
    );
};

export default WhoWe;
